
export const envSettings = {
  'tenant': 'unibas'
};
